// Section1.js
import React from 'react';

const Section3 = () => {

    return (
        <div className="section-container">
            <div className="text-column">
                <h2 className='subtitle-section' style={{ 'maxWidth': '500px' }}>CONHEÇA MELHOR QUEM CRIOU O CONTEÚDO</h2>
                <h3 className='text blue'> Ulisses Oliveira</h3>

                <p className='text'>
                    Sou professor por formação, com mais de 15 anos de experiência no mundo corporativo, onde atualmente ocupo os cargos de Diretor Comercial e Gerente de Produto de Inovação.<br /><br />
                    Ao longo da minha carreira, tive a oportunidade de liderar times multidisciplinares nas áreas de atendimento, vendas e produtos, tanto em grandes empresas como em startups.<br /><br />
                    Essa diversidade de experiências me proporcionou uma visão ampla e estratégica, permitindo-me navegar com sucesso por diferentes contextos empresariais.<br /><br />
                    Uma das minhas paixões é incentivar meus colaboradores a explorarem a arte de criar apresentações para seus dados. Acredito firmemente que esse é um elemento crucial para a compreensão e transmissão eficaz das informações.<br /><br />
                    Ao empoderar minha equipe a expressar suas experiências por meio de apresentações, estimulo a geração de conhecimento interno e a construção de uma cultura colaborativa.</p>

            </div>
            <div className="image-column">
                <img
                    src="indicador.jpg"
                    alt="Ulisses Oliveira"
                    style={{ 'maxHeight': '450px', 'maxWidth': '400px', 'borderRadius': '150px' }}
                />
            </div>
        </div>
    );
};

export default Section3;
